import { getQuery } from './core';

interface ITestDownloadArgs {
    certificateId: string;
    firstName?: string;
    lastName?: string;
    middleName?: string;
}

export const testDownload = ({ certificateId, firstName, lastName, middleName }: ITestDownloadArgs) =>
    window.open(
        `/api/certificate/testDownload?${getQuery({ certificateId, firstName, lastName, middleName })}`,
        '_blank',
    );

interface IDownloadArgs {
    certificateId: number;
    endPoint?: string;
}

export const download = ({ certificateId, endPoint }: IDownloadArgs) =>
    window.open(`${endPoint ? endPoint : ''}/api/certificate/download?${getQuery({ certificateId })}`, '_blank');
